import { FunctionComponent } from "react";

const App: FunctionComponent = () => {
  return <div>Hello World!!!</div>;
};

export default App;
